import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import {
  reset,
  setDescription,
  updateRestrictionIpDescription,
} from 'features/restrictionIp/restrictionIpUpdateSlice'
import classNames from 'classnames'
import { fetchRestrictionIps } from 'features/restrictionIp/restrictionIpListSlice'

const RestrictionIpUpdate = ({ handleClose, id, currentDescription }) => {
  const { description, maxLength } = useSelector(
    state => state.restrictionIp.restrictionIpUpdate
  )
  const dispatch = useDispatch()
  useEffect(() => () => dispatch(reset()), [dispatch])
  useEffect(() => {
    dispatch(setDescription(currentDescription))
  }, [dispatch, currentDescription])
  return (
    <ConfirmModal
      title="수정"
      handleClose={handleClose}
      onConfirm={async () => {
        await dispatch(updateRestrictionIpDescription({ id, description }))
        await dispatch(fetchRestrictionIps())
      }}
      confirmText="저장">
      <table className="tbl_layer">
        <caption className="hide_caption">IP 입력 표</caption>
        <colgroup>
          <col width="161" />
          <col />
        </colgroup>
        <tbody>
          <tr className="tr_box">
            <th scope="row">설명</th>
            <td>
              <div className="inner_cell">
                <div
                  className={classNames('box_textarea2 textarea_s', {
                    on: description,
                  })}>
                  <label htmlFor="tfArea" className="lab_txt" />
                  <textarea
                    name="tfArea"
                    id="tfArea"
                    className="tf_area"
                    value={description}
                    maxLength={maxLength}
                    onChange={e =>
                      dispatch(
                        setDescription(
                          e.target.value
                            .replace(/\n/g, '')
                            .substring(0, maxLength)
                        )
                      )
                    }></textarea>
                  <span className="num_byte">
                    <span className="screen_out">작성가능한 총 텍스트 수</span>
                    {maxLength - description.length}
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </ConfirmModal>
  )
}

export default RestrictionIpUpdate

RestrictionIpUpdate.propTypes = {
  currentDescription: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
}
